import React, { Component,useState } from "react";
import { Avatar as MuiAvatar } from "@mui/material";
import { IconButton, Tooltip } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";


export class MyDiv extends Component {
  render() {
    let className = "",
      title = "";
    if (this.props.className !== undefined) {
      className = this.props.className;
    }
    if (this.props.title !== undefined) {
      title = this.props.title;
    }
    return (
      <div className={className} title={title}>
        {this.props.children}
      </div>
    );
  }
}

export class PTag extends Component {
  render() {
    let className = "";
    if (this.props.className !== undefined) {
      className = this.props.className;
    }
    return <p className={className}>{this.props.children}</p>;
  }
}

export class LabelTag extends Component {
  render() {
    let className = "";

    if (this.props.className !== undefined) {
      className = this.props.className;
    }
    return <label className={className}>{this.props.children}</label>;
  }
}
export class SpanTag extends Component {
  render() {
    let className = "";

    if (this.props.className !== undefined) {
      className = this.props.className;
    }
    return <span className={className}>{this.props.children}</span>;
  }
}
export class StrongTag extends Component {
  render() {
    let className = "";

    if (this.props.className !== undefined) {
      className = this.props.className;
    }
    return <strong className={className}>{this.props.children}</strong>;
  }
}
export class HeadingOne extends Component {
  render() {
    let className = "";

    if (this.props.className !== undefined) {
      className = this.props.className;
    }
    return <h1 className={className}>{this.props.children}</h1>;
  }
}
export class HeadingTwo extends Component {
  render() {
    let className = "";

    if (this.props.className !== undefined) {
      className = this.props.className;
    }
    return <h2 className={className}>{this.props.children}</h2>;
  }
}
export class HeadingThree extends Component {
  render() {
    let className = "";

    if (this.props.className !== undefined) {
      className = this.props.className;
    }
    return <h3 className={className}>{this.props.children}</h3>;
  }
}
export class HeadingFour extends Component {
  render() {
    let className = "";

    if (this.props.className !== undefined) {
      className = this.props.className;
    }
    return <h4 className={className}>{this.props.children}</h4>;
  }
}
export class HeadingFive extends Component {
  render() {
    let className = "";

    if (this.props.className !== undefined) {
      className = this.props.className;
    }
    return <h5 className={className}>{this.props.children}</h5>;
  }
}
export class HeadingSix extends Component {
  render() {
    let className = "";

    if (this.props.className !== undefined) {
      className = this.props.className;
    }
    return <h6 className={className}>{this.props.children}</h6>;
  }
}
export class Loader extends Component {
  render() {
    return (
      <div className="center">
        <div className="loader">
          <img src={require("../../assets/images/favicon.png")} alt="logo" />
        </div>
      </div>
    );
  }
}

// Avatar Start

function stringToColor(string) {
  let hash = 0;
  for (let i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }
  let color = "#";
  for (let i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 9)) & 0xaa;
    color += `aa${value.toString(16)}`.slice(-2);
  }
  return color;
}


function stringAvatar(name = "User") {
  const initials = name
    .split(" ")
    .map(part => part[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();

  return {
    sx: { bgcolor: stringToColor(name),
          color: "#ffffff !important" },
    children: initials,
  };
}


export function Avatar({ name, src, size = 40, round = "50%", sx = {}, ...props }) {
  const avatarProps = src
    ? {} // If image is available, skip initials and bg
    : stringAvatar(name);

  return (
    <MuiAvatar
      src={src}
      {...avatarProps}
      sx={{
        width: size,
        height: size,
        borderRadius: round,
        fontSize: size * 0.4,
        ...avatarProps.sx,
        ...sx,
      }}
      {...props}
    />
  );
}


// Avatar End


/** Currency formatter */
// const formatINR = (value) =>
//   new Intl.NumberFormat("en-IN", {
//     style: "currency",
//     currency: "INR",
//     maximumFractionDigits: 0,
//   }).format(value);


// export function MaskedCurrency({
//   value,
//   maskedText = "******",
//   showLabel = false,
// }) {
//   const [show, setShow] = useState(false);

//   if (value === null || value === undefined) return "-";

//   return (
//     <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
//       {show ? formatINR(value) : maskedText}

//       <Tooltip title={show ? "Hide amount" : "Show amount"}>
//         <IconButton size="small" onClick={() => setShow(prev => !prev)}>
//           {show ? <VisibilityOff /> : <Visibility />}
//         </IconButton>
//       </Tooltip>
//     </span>
//   );
// }


/** Currency formatter */
const formatINR = (value) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(value);

export function MaskedCurrency({
  value,
  masked = false,
  maskedText = "******",
  showToggle = true,
}) {
  const [show, setShow] = useState(!masked);

  if (value === null || value === undefined) return "-";

  // 👉 If masking is disabled, just show currency
  if (!masked) {
    return <span>{formatINR(value)}</span>;
  }

  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
      {show ? formatINR(value) : maskedText}

      {showToggle && (
        <Tooltip title={show ? "Hide amount" : "Show amount"}>
          <IconButton size="small" onClick={() => setShow(prev => !prev)}>
            {show ? <VisibilityOff /> : <Visibility />}
          </IconButton>
        </Tooltip>
      )}
    </span>
  );
}
